import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from './../../../core/service/base/data.service';
import { MessageService } from './../../../core/service/message.service';
import { ProgressBarService } from './../../../core/service/progress-bar.service';
import { Observable, catchError, map } from 'rxjs';
import { BrfMortgagePrescription } from '../../model/brf-mortgage-prescription';

@Injectable()
export class BrfMortgagePrescriptionService extends DataService<BrfMortgagePrescription> {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) private _config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(_client, _config, messageService, BrfMortgagePrescription, progressBar, 'brf-mortgage-prescription');
  }

  getFilterDefinition(): Observable<{
    companyId: string;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client
      .get<any>(`${this.endpoint}/filter`)
      .pipe(
        map(res => res.filter),
        map(res => {
          return {
            companyId: res.companyId ?? '',
            selectedFields: Array.isArray(res.selectedFields)
              ? res.selectedFields
              : ['companyId'],
            defaultFields: ['companyId'],
          };
        })
      )
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }
}
